import { render, staticRenderFns } from "./UsersOverview.vue?vue&type=template&id=27c9b8ee&scoped=true&"
import script from "./UsersOverview.vue?vue&type=script&lang=js&"
export * from "./UsersOverview.vue?vue&type=script&lang=js&"
import style0 from "./UsersOverview.vue?vue&type=style&index=0&id=27c9b8ee&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c9b8ee",
  null
  
)

export default component.exports